import { OnInit } from '@angular/core';
import { SessionTimerService } from '../services/session-timer.service';
import { CountdownComponent } from 'ngx-countdown';
import { EnvService } from '../env.service';
import { SessionTimerStatus } from '../objects/Session';
import { ConfirmationService } from '../services/confirmation.service';
import { HeaderService } from '../services/header.service';
import { MainLoadingService } from '../services/main-loading.service';
import { Router } from '@angular/router';
import { BodyOutputType, ToasterService } from 'angular2-toaster';
import { Toaster } from '../objects/ToasterObject';
import { ToasterMessageService } from '../services/toaster-message.service';
import { TokenManager } from '../Globals';
import { Globals } from '../objects/Globals';
import { LoginService } from '../services/login.service';
import { BsModalService } from 'ngx-bootstrap';
import { SidePopupService } from '../services/side-popup.service';
var SessionTimerComponent = /** @class */ (function () {
    function SessionTimerComponent(globals, sessionTimerService, envService, confirmationService, headerService, mainLoadingService, router, toasterMessageService, toasterService, tokenManager, loginService, modalService, sidePopupService) {
        var _this = this;
        this.globals = globals;
        this.sessionTimerService = sessionTimerService;
        this.envService = envService;
        this.confirmationService = confirmationService;
        this.headerService = headerService;
        this.mainLoadingService = mainLoadingService;
        this.router = router;
        this.toasterMessageService = toasterMessageService;
        this.toasterService = toasterService;
        this.tokenManager = tokenManager;
        this.loginService = loginService;
        this.modalService = modalService;
        this.sidePopupService = sidePopupService;
        this.config = {
            leftTime: 30,
            format: 's',
            demand: true,
            notify: [30]
        };
        this.cycleConfig = {
            leftTime: 30,
            format: 's',
            demand: true,
            notify: [1]
        };
        this.sessionTimerService.sessionTimerChanged$.subscribe(function (result) {
            switch (result) {
                case SessionTimerStatus.START:
                    _this.resetAndBegin();
                    break;
                case SessionTimerStatus.RESET:
                    _this.resetAndBegin();
                    break;
                case SessionTimerStatus.STOP:
                    _this.stop();
                    break;
            }
        });
        this.sessionTimerService.keepSessionAliveChanged$.subscribe(function (result) {
            // begin the countdown to remove
            if (result) {
                _this.cycleCountdown.restart();
                _this.cycleCountdown.begin();
            }
            else {
                _this.cycleCountdown.stop();
            }
        });
        this.config.leftTime = this.envService.sessionTimeout * 60;
        var leftTime = this.envService.sessionTimeout * 60;
        var keepAliveTime = Math.round((leftTime - 40) * 0.8); // 80% of left time minus 40seconds notify
        this.cycleConfig.leftTime = keepAliveTime;
    }
    SessionTimerComponent.prototype.ngOnInit = function () {
    };
    SessionTimerComponent.prototype.resetAndBegin = function () {
        this.countdown.restart();
        this.countdown.begin();
    };
    // reset() {
    //   this.countdown.restart();
    //   this.countdown.begin();
    // }
    SessionTimerComponent.prototype.stop = function () {
        this.countdown.stop();
    };
    SessionTimerComponent.prototype.handleEvent = function (event) {
        var _this = this;
        if (event.action == "notify") {
            this.countdown.stop();
            this.confirmationService.confirmTimeout('Session timeout', 'Your session is about to end. You will be automatically logged out in', 30, ["Log out now, CANCEL", "Stay Logged In"]).subscribe(function (respond) {
                if (respond.answer == "Stay Logged In") {
                    _this.countdown.restart();
                    _this.countdown.begin();
                    _this.headerService.keepSessionAlive().subscribe(function (result) {
                        //console.log(result);
                    });
                }
                else {
                    _this.logOutSession();
                }
            });
        }
    };
    SessionTimerComponent.prototype.handleCycleEvent = function (event) {
        if (event.action == "notify") {
            this.countdown.stop();
            this.cycleCountdown.restart();
            this.cycleCountdown.begin();
            this.headerService.keepSessionAlive().subscribe(function (result) {
                //console.log(result);
            });
        }
    };
    SessionTimerComponent.prototype.logOutSession = function () {
        var _this = this;
        this.mainLoadingService.setLoading(true);
        this.headerService.setSessionAlive(false);
        this.sessionTimerService.stopSessionTimer();
        this.headerService.endSession().subscribe(function (result) {
            if (result == "1") {
                _this.popToast("Info", "Your session has ended", "info");
            }
            _this.mainLoadingService.setLoading(false);
            _this.clear();
            _this.router.navigate(['/login']);
        }, function (error) {
            _this.mainLoadingService.setLoading(false);
            _this.popToast("Error", "Unable to process action", "error");
        });
    };
    SessionTimerComponent.prototype.popToast = function (title, body, type) {
        var _this = this;
        var toast = {
            type: type,
            title: title,
            body: body,
            showCloseButton: true,
            bodyOutputType: BodyOutputType.TrustedHtml,
            onShowCallback: function (toast) {
                var toaster = new Toaster();
                toaster.id = toast.toastId;
                toaster.timestamp = Date.now();
                toaster.title = toast.title;
                toaster.content = toast.body;
                _this.toasterMessageService.pushToaster(toaster);
            }
        };
        this.toasterService.pop(toast);
    };
    SessionTimerComponent.prototype.clear = function () {
        this.globals.Session = null;
        this.tokenManager.clear();
        this.toasterMessageService.clearToaster();
        this.loginService.setSession(null);
        this.hidesAllModals();
    };
    SessionTimerComponent.prototype.hidesAllModals = function () {
        if (this.confirmationService.bsModalRef) {
            this.confirmationService.bsModalRef.hide();
        }
        for (var i = 1; i <= this.modalService.getModalsCount(); i++) {
            this.modalService.hide(i);
        }
        document.body.classList.remove('modal-open');
        this.sidePopupService.removePopup();
    };
    return SessionTimerComponent;
}());
export { SessionTimerComponent };
